<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-one">
<h1><strong>Chapter One</strong></h1>
<div class="section level2" id="appetizers-all-the-young-dudes-cooking-the-foods">
<h2>Appetizers: All the Young Dudes Cooking the Foods</h2>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?128e25f2